<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
  <div class="card ">
    <div class="card-body">
      <div class="card-header bg-primary">
        <div style="float: left;">
          <h2><i class="fa fa-users"></i>รายการขอเกี้ยวที่อนุมัติแล้ว ปี {{selecyear}}</h2>
        </div>
        <!-- 
          <div class="card-tools">
              <button type="button" class="btn btn-tool" (click)="Loadlistaskformoney();"><i class="fas fa-sync"></i>
              </button>
          </div> 
        -->
      </div>
      <hr>
      <div class="row d-flex justify-content-around">
        <div class="col-auto">
          <ul class="nav nav-pills mr-auto p-2">
            <li (click)="setselect[0]=1" class="nav-item">
              <a class="nav-link active" data-toggle="tab">
                <i class="fas fa-arrow-alt-circle-right"></i> เลือกโซน
                <span class="badge bg-warning"></span>
              </a>
            </li>
            <li (click)="setselect[0]=2" class="nav-item">
              <a class="nav-link" data-toggle="tab">
                <i class="fas fa-arrow-alt-circle-right"></i> เลือกวันที่อนุมัติ
                <span class="badge bg-warning"></span></a>
            </li>
            <li (click)="setselect[0]=3" class="nav-item">
              <a class="nav-link" data-toggle="tab">
                <i class="fas fa-arrow-alt-circle-right"></i> เลือกวันที่โอน
                <span class="badge bg-warning"></span></a>
            </li>
            <li (click)="setselect[0]=4" class="nav-item">
              <a class="nav-link" data-toggle="tab">
                <i class="fas fa-arrow-alt-circle-right"></i> ระบุโควตา
                <span class="badge bg-warning"></span></a>
            </li>
          </ul>
        </div>

        <div class="col-auto">
          <mat-form-field appearance="fill">
            <mat-label>เลือกปี</mat-label>
            <mat-select disableRipple [(ngModel)]="selecyear" (ngModelChange)="select_data()">
              <mat-option value="6465">ปี 64/65</mat-option>
              <mat-option value="6566">ปี 65/66</mat-option>
              <mat-option value="6667">ปี 66/67</mat-option>
              <mat-option value="6768">ปี 67/68</mat-option>
              <mat-option value="6869">ปี 68/69</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-auto" style="float: right;" *ngIf="setselect[0]==1">
          <table class="example-full-width" style="width: 100%">
            <tr style="text-align:center">
              <td>
                <mat-form-field appearance="fill">
                  <mat-label>เลือกโซน</mat-label>
                  <mat-select disableRipple [(ngModel)]="szone">
                    <mat-option value="" selected disabled> -- กรุณาเลือกโซน --</mat-option>
                    <mat-option *ngFor="let item of zonecode" [value]="item.SUPZONE">{{item.SUPZONE}} |
                      {{item.ZONENAME}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <button mat-raised-button color="primary" (click)="select_data();" [disabled]="!szone">
                  <i class="fas fa-check"></i>ตกลง</button>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-auto" style="float: right;" *ngIf="setselect[0]==4">
          <table class="example-full-width" style="width: 100%">
            <tr style="text-align:center">
              <td>
                <mat-form-field class="example-form-field" appearance="fill">
                  <mat-label>เลขโควตา 10 ตัว</mat-label>
                  <input matInput type="text" [(ngModel)]="fmcode" name="fmcode">
                  <button *ngIf="fmcode" matSuffix mat-icon-button aria-label="Clear" (click)="fmcode=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </td>
              <td>
                <button mat-raised-button color="primary" (click)="Loadlistaskformoney();" [disabled]="!fmcode">
                  <i class="fas fa-check"></i>ตกลง</button>
            </tr>
          </table>
        </div>
        <div class="col-auto" style="float: right;" *ngIf="setselect[0]==2||setselect[0]==3">
          <table class="example-full-width" style="width: 100%">
            <tr style="text-align:center">
              <td>
                <mat-form-field appearance="fill">
                  <mat-label>ช่วงวันที่</mat-label>
                  <mat-date-range-input [rangePicker]="picker" disabled>
                    <input matStartDate [(ngModel)]="dateSelet[0]" placeholder="วันที่เริ่มต้น">
                    <input matEndDate [(ngModel)]="dateSelet[1]" placeholder="วันที่สุดท้าย">
                  </mat-date-range-input>
                  <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                </mat-form-field>
              </td>
              <td>
                <button mat-raised-button color="primary" (click)="Loadlistaskformoney();">
                  <i class="fas fa-check"></i>ตกลง</button>
              </td>
              <td></td>
              <td>
                <div class="example-label"><mat-label>ช่วงวันที่เลือก
                    {{dateSelet[0]|adtob}} - {{dateSelet[1]|adtob}}</mat-label>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-auto" style="text-align:right">
          <button class="btn btn-outline-success btn-sm" [disabled]="setselect[2]==0" (click)="ExportExcel()">
            <i class="far fa-file-excel"></i> Download
            <span class="badge badge-light">{{setselect[2]}}</span>
          </button>
        </div>
        <mat-progress-bar *ngIf="isload[1]" mode="indeterminate"></mat-progress-bar>
      </div>
      <div>
        <!--
        <mat-form-field appearance="standard">
          <mat-label>ค้นหาชื่อ หรือ เลขที่คำขอ จำนวนเงิน</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="รายการที่ต้องการหา" #input>
        </mat-form-field>
        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="list6566" matSort>
            <ng-container matColumnDef="no">
              <th mat-header-cell *matHeaderCellDef> NO </th>
              <td mat-cell *matCellDef="let element; let i = index;">{{i+1}}</td>
            </ng-container>

            <ng-container matColumnDef="doc_no">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>เลขที่คำขอ</th>
              <td mat-cell *matCellDef="let element"> {{element.docid}} </td>
            </ng-container>

            <ng-container matColumnDef="supportter">
              <th mat-header-cell *matHeaderCellDef> <mat-icon>person_add</mat-icon> </th>
              <td mat-cell *matCellDef="let element"> {{element.supcode.trim()}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>วันที่</th>
              <td mat-cell *matCellDef="let element"> {{THtoLocalstring(element.datepost)}} </td>
            </ng-container>
            <ng-container matColumnDef="FMCODE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>โควตา</th>
              <td mat-cell *matCellDef="let element"> {{element.FMCODE}} </td>
            </ng-container>

            <ng-container matColumnDef="fullname">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ชื่อ-นามสกุล</th>
              <td mat-cell *matCellDef="let element"> {{element.fmname}} </td>
            </ng-container>

            <ng-container matColumnDef="comment1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>เรื่องที่ขอ</th>
              <td mat-cell *matCellDef="let element"> {{element.type_money_sub}}-{{element.comment1}} </td>
            </ng-container>

            <ng-container matColumnDef="countmoney">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>จำนวนเงิน</th>
              <td mat-cell *matCellDef="let element"> {{element.money_amt|number}} </td>
            </ng-container>

            <ng-container matColumnDef="credit_approved">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>เงินที่อนุมัติ</th>
              <td mat-cell *matCellDef="let element"> {{element.credit_approved|number}} </td>
            </ng-container>

            <ng-container matColumnDef="dateapprove">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>วันที่อนุมัติ</th>
              <td mat-cell *matCellDef="let element"> {{THtoLocalstring(element.dateapprove)}} </td>
            </ng-container>

            <ng-container matColumnDef="Date_debt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>วันที่โอน</th>
              <td mat-cell *matCellDef="let element"> {{THtoLocalstring2(element.Date_debt)}} </td>
            </ng-container>

            <ng-container matColumnDef="bank">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ธนาคาร</th>
              <td mat-cell *matCellDef="let element"> {{element.bank}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>สถานะ</th>
              <td mat-cell *matCellDef="let element"> {{element.docdesc}} </td>
            </ng-container>

            <ng-container matColumnDef="timeline">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Timeline</th>
              <td mat-cell *matCellDef="let element">
                <button type="button" class="btn btn-primary btn-sm" (click)="Datainmodel(element.docid)"
                  data-toggle="modal" data-target="#Timeline">
                  <i class="far fa-clock"></i>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="save">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>บันทึก</th>
              <td mat-cell *matCellDef="let element">
                <button type="button" (click)="Datainmodel(element.docid)" class="btn btn-warning btn-sm"
                  data-toggle="modal" data-target="#Savestatus"
                  *ngIf="(selecyear >= '6768')&&(userlv==='5'||userlv==='6'||userlv==='7'||userlv==='9'||userlv==='10')">
                  <i class="far fa-edit"></i>
                </button>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displaylist ; sticky: true;"></tr>
            <tr mat-row *matRowDef="let row; columns: displaylist;"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[10, 25, 50 ,100 ,250 , 500, 1000,2000]" showFirstLastButtons
            aria-label="Select page of periodic elements"></mat-paginator>
        </div>-->

        <table class="table table-sm table-striped table-bordered" #listdoc00>
          <thead>
            <tr style="text-align:center">
              <!--<th scope="col"> เลือก </th>
              <th scope="col"> # </th>-->
              <th scope="col">เลขที่คำขอ</th>
              <th scope="col"><mat-icon>person_add</mat-icon> </th>
              <th scope="col">วันที่</th>
              <th scope="col">โควตา</th>
              <th scope="col">ชื่อ-นามสกุล</th>
              <!--<th scope="col">หัวข้อ</th>-->
              <th scope="col">เรื่องที่ขอ</th>
              <th scope="col">จำนวนเงิน</th>
              <th scope="col">เงินที่อนุมัติ</th>
              <th scope="col">วันที่อนุมัติ</th>
              <th scope="col">วันที่โอน</th>
              <th scope="col">Bank</th>
              <th scope="col">action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of dataList" style="text-align:center">
              <!--<td>
                <section class="example-section">
                  <mat-checkbox [(ngModel)]="item.modify" class="example-margin"></mat-checkbox>
                </section>
              </td>
              <td></td>-->
              <td>{{item.docid}} </td>
              <td>{{item.supcode.trim()}}</td>
              <td>{{THtoLocalstring(item.datepost)}}</td>
              <td>{{item.FMCODE}}</td>
              <td style="text-align:left">{{item.fmname}}</td>
              <td style="text-align:left"><b>{{item.type_money_sub}}</b>-{{item.comment1}}
              </td>
              <td style="text-align:right">{{item.money_amt|number}}</td>
              <td style="text-align:right">{{item.credit_approved|number}}</td>
              <td>{{THtoLocalstring(item.dateapprove)}}</td>
              <td>{{THtoLocalstring2(item.Date_debt)}}</td>
              <td style="text-align:center">{{item.bank}}</td>
              <td style="text-align:center">
                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#Timeline"
                  (click)="Datainmodel([item])">
                  <i class="far fa-clock"></i>
                </button>
                <button type="button" class="btn btn-warning btn-sm" data-toggle="modal" data-target="#Savestatus"
                  (click)="Datainmodel([item])"
                  *ngIf="(selecyear >= '6768')&&(userlv=='5'||userlv=='6'||userlv=='7'||userlv=='9'||userlv=='10')">
                  <i class="far fa-edit"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal Timeline -->
<div class="modal fade" id="Timeline" tabindex="-1" role="dialog" aria-labelledby="TimelineLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngFor="let item of datainmodal">
      <div class="modal-header">
        <h5 class="modal-title" id="TimelineLabel">Timeline เลขที่คำขอ : {{item.docid}} </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="timeline">
          <!-- timeline time label -->
          <div class="time-label">
            <span class="bg-blue"><i class="fas fa-clock"></i> {{THtoLocalstring(item.datepost)}}</span>
          </div>
          <!-- /.timeline-label -->
          <!-- timeline item -->
          <div>
            <i class="fas fa-envelope bg-blue"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-blue">ผู้จัดการโซน - [{{item.sup_U}}]</h3>
              <div class="timeline-body">
                {{item.comment1}} | {{item.money_amt.toLocaleString('ar-TH')}} บาท
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <div class="time-label">
            <span class="bg-yellow"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment3date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-comments bg-yellow"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-yellow">พนักงานสินเชื่อ - [{{item.fn_U}}]</h3>
              <div class="timeline-body">
                | {{item.comment3}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- Start timeline item -->
          <div class="time-label">
            <span class="bg-green"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment4date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-user bg-green"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header no-border bg-green">หัวหน้าสินเชื่อ - [{{item.head_U}}]</h3>
              <div class="timeline-body">
                |{{item.comment4}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- Start timeline item -->
          <div class="time-label">
            <span class="bg-info"><i class="fas fa-clock"></i> {{THtoLocalstring(item.comment5date)}}</span>
          </div>
          <!-- timeline item -->
          <div>
            <i class="fas fa-user bg-info"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header no-border bg-info">ผู้ช่วย ผจก.สินเชื่อ - [{{item.adj_U}}]</h3>
              <div class="timeline-body">
                | {{item.comment5}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->

          <!-- timeline time label -->
          <div class="time-label">
            <span class="bg-purple"><i class="fas fa-clock"></i> {{THtoLocalstring(item.dateapprove)}}</span>
          </div>
          <!-- /.timeline-label -->
          <div>
            <i class="fas fa-tasks bg-purple"></i>
            <div class="timeline-item ">
              <span class="time"></span>
              <h3 class="timeline-header bg-purple">ผจก.สินเชื่อ - [{{item.approve_U}}]</h3>
              <div class="timeline-body">
                | {{item.comment6}}
              </div>
            </div>
          </div>
          <!-- END timeline item -->
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Timeline -->
<!-- แบบบันทึกสถานะ -->

<div class="modal fade" id="Savestatus" tabindex="-1" role="dialog" aria-labelledby="SaveLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="TimelineLabel">บันทึกสถานะหัวหน้าแผนกสินเชื่อ</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngFor="let item of datainmodal">
        <p>เลขที่คำขอ : {{item.docid}} | {{item.fmname}} |
          {{item.comment1}} | {{item.money_amt.toLocaleString('ar-TH')}} บาท
        </p>
        <div *ngFor="let item of datainmodal">
          <div class="input-group mb-3">
            <table style="width:100%">
              <tr style="text-align:center">
                <th style="width:50%">วงเงินที่ขอ</th>
                <th style="width:50%">วงเงินที่จะอนุมัติ </th>
              </tr>
              <tr style="text-align:center">
                <td>{{item.money_amt|number}}</td>
                <td style="color: red;">
                  <input type="number" class="form-control" (change)="ckcredit_approved()" [(ngModel)]="credit_approved"
                    id="credit_approved">
                </td>
              </tr>
            </table>
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text">โอนเข้าธนาคาร [{{chkAccept[2]}}]</span>
            <div class="col-6 text-right">
              <ul class="nav nav-pills nav-fill mb-3" id="vert-tabs-tab" role="tablist" aria-orientation="horizontal">
                <li class="nav-item " role="presentation">
                  <a class="nav-item nav-link" id="tabs-tab1" (click)="chkAccept[2]='LH';" data-toggle="pill">
                    LH</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-item nav-link" id="tabs-tab2" (click)="chkAccept[2]='KTB';" data-toggle="pill">
                    KTB</a>
                </li>
                <li class="nav-item" role="presentation">
                  <a class="nav-item nav-link" id="tabs-tab3" (click)="chkAccept[2]='SG';" data-toggle="pill">
                    SG</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="input-group mb-3">
            <!--<label class="form-label">วันที่โอนเงิน - {{chkAccept[3].toLocaleString("th-TH")}}</label>-->
            <span class="input-group-text">วันที่โอนเงิน ({{chkAccept[3]|adtob}})</span>
            <input [(ngModel)]="chkAccept[3]" id="datetransfer" type="date" class="form-control">
          </div>

          <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="ป้อนหมายเหตุ(ถ้ามี)" [(ngModel)]="comment_accept">
            <button class="btn btn-outline-success btn-sm" (click)="edit_approved(item.docid);"
              *ngIf="chkAccept[0] == 1"><i class="far fa-check-circle"></i> บันทึกเกี๊ยว</button>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- แบบบันทึกสถานะ -->
<app-footer></app-footer>